<template>
  <div>
    <div style="max-width: 800px; width: 100%; margin: auto;">
        <h1 style="text-align:center;font-weight:300;font-size:36px;">
            {{ app_name }}
        </h1>
        <div
            style="font-size: 18px;text-align:center;margin:auto;"
        >
            Litigation Locker, LLC - Privacy Policy
        </div>
        <br /><br />
        <div
            style="font-size: 14px; line-height: 18px;font-weight: 300px;"
        >
            <v-alert
                :value="true"
                type="info"
            >
                This Privacy Policy was last updated October 18, 2022.<br /><br />
                This policy only describes how Litigation Locker handles your Data as a Data Processor. You may be subject to additional third-party privacy policies. Contact <span class="legalFoot" /> for more information.
            </v-alert>
            <br /><br />
            This policy describes the information we collect, why we collect it, who it is shared with when using our services. This also describes how to manage, update, export and delete this information.
            <br /><br />
            <b>Definitions:</b>
            <ul>
                <li>
                    <b>"We", "Us", "Our"</b> refers to Litigation Locker, LLC in this policy.
                </li>
                <li>
                    <b>"Customers", "Customer"</b> are entities or persons that directly use our services and those in which we have a direct financial, contractual, or mutual relationship with to. When using our services, we may identify these as, but not limited to: "Organization", "Law Firm", or "Law Office". 
                </li>
                <li>
                    <b>"Users", "User"</b> are clients or persons a Customer is using our services to solicit information from.
                </li>
            </ul>
            <br /><br />
            <b>API Disclosure:</b><br />
            We may utilize one or more of the following APIs from third parties to improve a Users and/or Customers experience, the use of which is subject to applicable privacy policies:<br /><br />
            <ul>
                <li>
                    <b>Google APIs</b> - <a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>
                    <ul>
                        <li>
                            Google Places API - The Google Places API is used to autocomplete and/or correct addresses in our services
                        </li>
                    </ul>
                </li>
                <li>
                    <b>DocuSign</b> - <a href="https://www.docusign.com/company/privacy-policy">https://www.docusign.com/company/privacy-policy</a>
                    <ul>
                        <li>
                            DocuSign API - DocuSign is used to electronically sign documents
                        </li>
                    </ul>
                </li>
                <li>
                    <b>DropBox Sign (HelloSign)</b> - <a href="https://www.hellosign.com/about/privacy">https://www.hellosign.com/about/privacy</a>
                    <ul>
                        <li>
                            DropBox Sign (HelloSign) is used to electronically sign documents
                        </li>
                    </ul>
                </li>
            </ul><br />

            <div
                style="font-weight: 700; font-size: 24px;margin-top: 50px;"
            >
                Your Consent
            </div>
            By using our services, you consent to our collection and use of your personal information as described in this privacy policy. If we change our Privacy Policies, we will notify you on our services to keep you informed of the data we collect and how we use it. Your acknowledgement and continued use of our services after any such change shall constitute your consent to such change.<br />
            <div
                style="font-weight: 700; font-size: 24px;margin-top: 50px;"
            >
                Information We Collect
            </div>
            We may collect personal information from all individuals that use our services. We may obtain this data in any of the following ways:
            <div
                style="font-weight: 500; font-size: 18px;margin-top: 25px;"
            >
                From You
            </div>
            You may provide us with personal information when using our services. Such information may include information such as: your name, email address, mailing address, phone number, personal health information, and/or other personally identifiable information.<br /><br />
            This information may be collected when you:
            <ul>
                <li>
                    Register or Log In
                </li>
                <li>
                    Update Personal Information
                </li>
                <li>
                    Complete a Form, Entry, or Activity
                </li>
                <li>
                    Upload a file
                </li>
                <li>
                    Reply to emails or messages within our services
                </li>
            </ul><br />
            We may be acting as a data processor on behalf of a Customer when collecting this data, and as such you may need to contact the Customer if you have questions or concerns about information you have provided. 

            <div
                style="font-weight: 500; font-size: 18px;margin-top: 25px;"
            >
                From Customers
            </div>
            Customers using our services may obtain, store, and upload information about you onto our services. When storing this information, we are acting as a data processor on behalf of the Customer. This information may be used to request additional information from Users, provide information to Users, or to preform data processing.<br /><br />
            Questions or concerns regarding information provided by a Customer should be directed to the customer directly. Unless the use, storage, or processing of such information violates our Privacy Policy or Terms of Service, we are unable to remove data provided by a Customer.

            <div
                style="font-weight: 500; font-size: 18px;margin-top: 25px;"
            >
                Automatically
            </div>
            When using our services, we automatically collect and store information about you that may be personally identifiable. <br /><br />Such information may include:
            <ul>
                <li>
                    Device, Usage, and/or Transactional Data - Information such as, but not limited to: your IP address, precice geolocation information, device identifiers and user agent string, referral and exit pages, date and time of a request, frequency of use, and error logs. This information is collected automatically, and cannot be opted out of.
                </li>
                <li>
                    Local Storage - Cookies and Local Browser Storage are small bits of text data stored on your device, and may be used to store information about your session, visits, or to track your activity on our services. Users may opt-out of this collection, however our services may not be functional without them.
                </li>
            </ul><br />
            <div
                style="font-weight: 700; font-size: 24px;margin-top: 50px;"
            >
                How We Use Your Information
            </div>
            Information collected about you is used to provide our services. Information collected on behalf of a Customer is part of providing this service, and is stored on behalf of and can be accessed by the Customer.<br /><br />We may use information you provide to:
            <ul>
                <li>
                    Update your personal account
                </li>
                <li>
                    Record activity on our services to improve the service
                </li>
                <li>
                    Prevent, Investigate, and respond to potential fraud, unauthorized access, breaches of our Terms of Service, or other malicious/illegal behavior
                </li>
                <li>
                    Provide, Improve, or Maintain our services
                </li>
                <li>
                    Contact you regarding your account, or to forward, route, and store messages to/from a customer to a user.
                </li>
            </ul><br /><br />
            If you have any concerns with how a Customer uses information you have provided, please contact the Customer.<br />

            <div
                style="font-weight: 700; font-size: 24px;margin-top: 50px;"
            >
                How We Share Your Information
            </div>
            We do not use any of your information for advertising purposes, nor do we sell, share, or otherwise distribute such information to data aggregators or advertisers.<br /><br />
        
            Your information is not shared, sold, or rented to third parties, except in the following circumstances:
            <ul>
                <li>
                    <b>Data Processing</b> - Information you provide is shared with and retained on behalf of the Customer that requested it.
                </li>
                <li>
                    <b>Law Enforcement</b> - We may share your personal information when we are legally compelled to do so under a lawful order. We also may share your personal information when there is reasonable belief that there may be threats to the safety of any person; violations of this Privacy Policy or our Terms of Service; or to protect the legal rights of third parties, including our employees, users, customers, or the public.
                </li>
                <li>
                    <b>Corporate Transactions</b> - Your personal information may be shared with third parties in the event of a sale or merger of our services.
                </li>
                <li>
                    <b>Testimonial</b> - Certain information you provide may be used in marketing or promotional material, however such information is anonymized and aggregated. We may ask your consent to share comments or feedback you provide on your experience using our services, and such comments may be used in promoting or marketing our services.
                </li>
            </ul><br />

            <div
                style="font-weight: 700; font-size: 24px;margin-top: 50px;"
            >
                How Long We Retain Your Information
            </div>
            Your information may be stored for as long as deemed necessary by the Customer, as long as that Customer has an active relationship with us. We may retain information for a longer period of time after a relationship ends in order to provide historical and auditing data.<br /><br />
            Device, Usage, and Transactional Data is stored for no longer than necessary. This information may be retained for up to 180 days. Certain information may be retained for longer if being used to actively improve our services, diagnose issues, or when auditing transactions.<br /><br />
            Information regarding certain events, such as submitting a form or entry, executing an electronic signature, or modifying account or billing information may be retained indefinitely for security and auditing purposes.<br />

            <div
                style="font-weight: 700; font-size: 24px;margin-top: 50px;"
            >
                How We Secure Your Information
            </div>
            We use secure socket layer technology (SSL) to encrypt your traffic to our services, however the Customer that collects information from a User is ultimately responsible for securing collected information. We do not control or secure information that is in possession of the Customer.<br /><br />
            In the event that you are accessing an insecure version of our services, you will not be permitted to complete the connection and your browser will display a warning notifying you that the connection is not secure. However, no method of transmission is 100% secure, and information in transit may be read or modified by software on your device. <br /><br />

            <div
                style="font-weight: 700; font-size: 24px;margin-top: 50px;"
            >
                How to Access and Correct Information
            </div>
            As a Customer, you may modify your information by logging in to our services and changing your settings as needed.<br /><br />
            As a User, access to reading or modifying of information may be restricted by the Customer that requested or provided such information. Users should contact the Customer to request removal or correction of any information stored on our services.<br />

            <div
                style="font-weight: 700; font-size: 24px;margin-top: 50px;"
            >
                Children's Privacy
            </div>
            Persons under 18 years of age (or under the age of majority in the jurisdiction in which they reside) may not be permitted to use our services, and if a Customer should need to collect information about a minor, that information should be provided by, and at the consent of, the minor's parent or guardian on behalf of the minor.<br /><br />
            Persons under the age of 13 may not be permitted to use our services at any time.<br /><br />
            In the event that a person is a minor, above the age of 13, and has been declared legally emancipated by a court, they may be permitted to use our services.<br /><br />
            Customers that provide User information are providing this information under the terms that they have determined that all Users provided are of the age of majority or meet an exemption. In the event that a User is a minor and does not have any of the above exemptions, the User data may be deleted from our services if found it was provided without parent or guardian’s consent.<br />

            <div
                style="font-weight: 700; font-size: 24px;margin-top: 50px;"
            >
                California Residents
            </div>
            Under the California Consumer Privacy Act, California residents have the right to know and request what data is collected about them when using our services. Information collected about Users may be used by Customers to aggregate data or to transmit to third parties, and as such Users should contact the Customer collecting this information if they have any questions about how the Customer uses their data.<br /><br />
            Our services do not collect information on behalf of third-party direct marketers, advertisers, or data brokers; nor do our services sell or solicit your information to other parties.<br /><br />
            California Residents have the right to:<br />
            <ul>
                <li>
                    opt-out of electronically providing personal information on our services. You may submit such information to a Customer via alternative methods, such as physical mail, over the phone, or via email. Customers may still enter a User's personal information into our services for their data processing purposes, and Users should contact these Customers to learn more about how their data will be used.
                </li>
                <li>
                    request access to all personal information collected in our services, regardless of when or how it was collected, unless doing so proves impossible, would violate another Users privacy, or would involve a disproportionate effort.
                </li>
            </ul><br /><br />
            If you wish to contact us about your consumer privacy rights under CCPA and CPRA, please contact us at help@litigationlocker.com. Requests for personal data or deletion must be directed to the Customer that requested such information.
        </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',

}
</script>

<style>

</style>